<template>
  <main id="app" class="library-main" :class="directionSystem" @click="toggleBaseLibraryMenu(null)">
    <library-loader v-if="showLoader"/>
    <router-view></router-view>
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LibraryLoader from '@/components/library-loader'
import { decodeJWT } from '@/utilityFunctions'
import config from '@/config.js'

export default {
  name: 'app',
  components: { LibraryLoader },
  data () {
    return {
      // Get the library slug from the router params,
      // or from the URL path (if the user entered a URL which is an invalid route)
      librarySlug: this.$route.params.librarySlug || this.$route.path.split('/')[1]
    }
  },
  computed: {
    ...mapState({
      lang: state => state.base.lang,
      directionSystem: state => state.base.directionSystem,
      showLoader: state => state.base.showLoader
    })
  },
  created () {
    const direction = sessionStorage.getItem('direction')
    // If we have a direction in a sessionStorage, store it -
    // for prevent loading again after set userLang
    if (direction) {
      this.$store.commit('SET_DIRECTION', direction)
    }
    require('@/assets/styles/library-style.css')
    if (localStorage.getItem('jwt')) {
      const jwt = decodeJWT(localStorage.getItem('jwt'))
      if (jwt.uuid) {
        config.setToken(localStorage.getItem('jwt'))
        if (localStorage.getItem('user')) {
          this.$store.dispatch('setUserData', JSON.parse(localStorage.getItem('user')))
        }
        this.$store.dispatch('getLibrary', this.librarySlug)
          .then(() => {
            this.$store.dispatch('getAllLibraries').then(() => {
              this.$store.dispatch('getRoles', this.librarySlug)
            })
          })
          .catch(() => {
            // If the library is blocked
            // go to error page
            this.$store.dispatch('setLoader', false)
            this.$router.push({ name: 'unauthorizedUser' })
          })
      } else {
        this.$store.dispatch('getLibraryInfo', this.librarySlug)
        this.selectRouting()
      }
    } else {
      this.$store.dispatch('getLibraryInfo', this.librarySlug)
      this.selectRouting()
    }
  },
  watch: {
    lang: function () {
      this.$i18n.locale = this.lang.localName
      this.$store.dispatch('setAttributeLang')
    }
  },
  methods: {
    ...mapActions(['toggleBaseLibraryMenu']),
    selectRouting () {
      // If we have a `collectionEntry` in the localStorage,
      // It means we came from an old link to enter to `collection-entry` page.
      if (localStorage.getItem('collectionEntry')) {
        this.$router.push('home-page/login?collectionEntry=' + localStorage.getItem('collectionEntry'))
      } else if (!this.$route.name) {
        // If the user enter with a wrong route, redirect to the `home-page`
        this.$router.push('/' + this.librarySlug + '/home-page')
        localStorage.removeItem('requestedUrl')
      } else if (this.$route.name !== 'homePage' && !this.$route.path.includes('home-page')) {
        // If the user enter with a inner route, but he's unauthorized,
        // Go to the `login-page` and save the `requestedUrl` to enter in after login.
        localStorage.setItem('requestedUrl', this.$route.fullPath)
        this.$router.push({ name: 'logIn' })
      } else {
        localStorage.removeItem('requestedUrl')
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~ag-grid-community/dist/styles/ag-grid.css";
  @import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>
